export default __webpack_public_path__ + "static/media/fresh-club-logo-filled.d1c166b4.svg";